import { render, staticRenderFns } from "./TrustSsnMismatch.vue?vue&type=template&id=8fb3aaa4&scoped=true"
import script from "./TrustSsnMismatch.vue?vue&type=script&lang=js"
export * from "./TrustSsnMismatch.vue?vue&type=script&lang=js"
import style0 from "./TrustSsnMismatch.vue?vue&type=style&index=0&id=8fb3aaa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb3aaa4",
  null
  
)

export default component.exports